import React from 'react';

const VerificationSuccess = () => {
  return (
    <div className="Profile-Verified">
      <div className=""> 
        <h1>✅ Profile Verified!</h1>
        <p>Thank you. Your identity has been successfully verified.</p>
      </div>
    </div>
  );
};

export default VerificationSuccess;